/* import __COLOCATED_TEMPLATE__ from './fake-list-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();